module.exports = __webpack_public_path__ + "static/media/wechat_icon.dda6a516.svg";